App.directive('cardPackage', ['$window', 'Config', '$mdDialog', '$state', '$rootScope', '$filter', function ($window, Config, $mdDialog, $state, $rootScope, $filter) {
    return {
    	restrict: 'AEC',
        scope: {
            // @TODO <HEALTH2019>
    	    isHealth: '<?',
    	    declaration: '<?',
            // @TODO </HEALTH2019>
            isHealthWithPayments: '<?',
            isHealthPzuw: '<?',
            package: '=',
            branch: '=',
            groupName: '=',
            proposedDate: '='
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/card-package.html',
        link: function(scope) {
            scope.package.groupName = scope.groupName;

            scope.userData = JSON.parse(window.sessionStorage.getItem('userObject'));
            scope.withRehabilitation = false;
            scope.canChangeRehabilitation = true;

            scope.rehabilitationVisible = scope.package.type != 'VIP';

// @TODO <HEALTH2019>
            function determineIfIsActive() {
                if (scope.isHealth || scope.isHealthWithPayments || scope.isHealthPzuw) {
                    if (scope.declaration) {
                        var status = scope.declaration.status;
                        scope.userData.hasActiveDeclaration = status === 'ACTIVE' || status === 'WITHDRAWN' || status === 'ENDED';
                        scope.userData.benefit = scope.declaration.benefit;
                    }
                }

                var isAnyChangeAllowed = false;
                if (scope.declaration && typeof scope.declaration.activeDate !== 'undefined' && scope.declaration.activeDate) {
                    var _activeDate = new Date(scope.declaration.activeDate);

                    var number = 5;
                    if (scope.isHealthWithPayments) {
                        number = 11; // in LUX MED we can downgrade package after 12 months.
                    }
                    _activeDate.setMonth(_activeDate.getMonth() + number);

                    var now = new Date();
                    if (now.getTime() >= _activeDate.getTime()) {
                        isAnyChangeAllowed = true;
                    }
                }

                if (scope.isHealthPzuw && $rootScope.CONFIGURATOR.healthInsurancePzuw.anniversaryChangesMonth === (new Date().getMonth() + 1)) {
                    isAnyChangeAllowed = true;
                }

                if (scope.userData.benefit) {
                    scope.currentBenefitWeight = scope.userData.benefit.weight;
                    if (isAnyChangeAllowed) {
                        scope.notActive = false;
                    } else {
                        let scopeType = $filter('healthInsuranceTypeToNumberFilter')(scope.package.type);
                        let declarationType = $filter('healthInsuranceTypeToNumberFilter')(scope.declaration.benefit.type);
                        let scopeVariant = $filter('healthInsuranceVariantToNumberFilter')(scope.package.variant);
                        let declarationVariant = $filter('healthInsuranceVariantToNumberFilter')(scope.declaration.benefit.variant);
                        scope.notActive = scope.userData.hasActiveDeclaration && !(scopeType >= declarationType && scopeVariant >= declarationVariant);
                        if (scope.isHealthPzuw && scope.declaration.rehabilitation) {
                            scope.canChangeRehabilitation = false;
                            scope.withRehabilitation = scope.rehabilitationVisible;
                        }
                    }
                }
            }

            if (scope.isHealth || scope.isHealthWithPayments || scope.isHealthPzuw) {
                scope.$watch('declaration', function (value) {
                    if (value) {
                        determineIfIsActive();
                    }
                });
            } else {
                determineIfIsActive();
            }
// @TODO </HEALTH2019>

            scope.changeRehabilitationStatus = function () {
                if (scope.canChangeRehabilitation) {
                    scope.withRehabilitation = !scope.withRehabilitation;
                }
            };

        	scope.next = function() {
                if (scope.userData.benefit) {
                    if (scope.notActive) {
                        return 0;
                    }
                }

                if (scope.withRehabilitation) {
                    scope.package.selectedRehabilitation = true;
                }

                if (scope.isHealthPzuw) {
                    $state.go('root.health.form', {
                        package: scope.package,
                        proposedDate: scope.proposedDate,
                        lastDeclaration: scope.declaration,
                    });
                } else if (scope.isHealthWithPayments) {
                    $state.go('root.home.healthInsuranceWithPayments.form', {
                        package: scope.package,
                        proposedDate: scope.proposedDate,
                        lastDeclaration: scope.declaration,
                    });
                } else if (scope.isHealth) {
                    $state.go('root.home.healthInsurance.form', {
                        package: scope.package,
                        proposedDate: scope.proposedDate
                    });
                } else {
                    $state.go('root.home.insurance.form', {package: scope.package, proposedDate: scope.proposedDate});
                }
            };
        }
    };
}]);
